import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dashboarditem',
  templateUrl: './dashboarditem.component.html',
  styleUrls: ['./dashboarditem.component.css']
})
export class DashboarditemComponent implements OnInit {
  @Input() result;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboarditem/dashboarditem.component.ts